import React, { Component } from 'react';
import Waypoint from 'react-waypoint';
import { connect } from 'react-redux';
import { arrayOf, object, shape, string, bool, func } from 'prop-types';
import classNames from 'classnames';
import { I18n } from '@fiverr-private/fiverr_context';
import SafePureComponent from '../shared/SafePureComponent';
import WithImpressions from '../shared/withImpressions';
import { validateDescription } from '../../utils/mainComponentsValidator';
import { sanitize } from '../../utils/sanitization';
import { getCurrentContent } from '../../utils/ugc/getCurrentContent';
import { isTranslated } from '../../utils/ugc/isTranslated';
import { BQ_GIG_DESCRIPTION_SEE_MORE } from '../../utils/bigQueryEvents';
import TranslatedBadge from '../shared/TranslatedBadge';
import Metadata from './Metadata';

import './style.scss';

const createMarkup = (data) => data ? { __html: data } : null;
const CLASSNAME = 'gig-description';

class Description extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showInfo: false
        };

        this.toggleCollapsed = this.toggleCollapsed.bind(this);
    }

    toggleCollapsed(event) {
        event.preventDefault();

        const { showInfo } = this.state;

        this.setState({
            showInfo: !showInfo
        });

        if (!showInfo) {
            this.reportShowInfoEvent();
        }
    }

    reportShowInfoEvent() {
        const { biEvents } = this.context;

        biEvents.sendBigQueryEvent({ eventName: BQ_GIG_DESCRIPTION_SEE_MORE });
    }

    onEnterWaypoint = () => {
        this.props.collectImpressions();
    }

    render() {
        const { description, metadataAttributes, showTranslatedBadge, impressionRef } = this.props;
        if (!validateDescription({ description })) {
            return null;
        }

        const showContent = classNames('description-content', { 'show': this.state.showInfo });
        const classes = classNames(CLASSNAME, { 'with-translated-badge': showTranslatedBadge });
        const { content } = description;
        const sanitizedContent = createMarkup(sanitize(content));
        const showKey = this.state.showInfo ? 'see_less' : 'see_more';

        return (
            <div className={classes} ref={impressionRef}>
                <header>
                    <h2 className="section-title"><I18n k={'gig_page_perseus.description.title'}/></h2>
                    {showTranslatedBadge && <TranslatedBadge/>}
                </header>
                {sanitizedContent &&
                <div className="description-wrapper">
                    <Waypoint onEnter={this.onEnterWaypoint}/>
                    <div className={showContent} dangerouslySetInnerHTML={sanitizedContent}/>
                    <div className="cover"/>
                    <button className="collapse-button" onClick={this.toggleCollapsed}>
                        <I18n k={`gig_page_perseus.description.${showKey}`}/>
                    </button>
                </div>
                }
                <Metadata metadataAttributes={metadataAttributes}/>
            </div>
        );
    }
}

Description.propTypes = {
    showTranslatedBadge: bool,
    description: shape({
        content: string,
        metadataAttributes: arrayOf(
            shape({
                name: string,
                options: arrayOf(string)
            })
        )
    }),
    collectImpressions: func
};

Description.contextTypes = {
    general: object,
    biEvents: object
};

const mapStateToProps = ({ ugc }) => {
    const { description } = getCurrentContent({ ugc });

    return {
        description,
        showTranslatedBadge: isTranslated(ugc)
    };
};

const ConnectedDescription = connect(mapStateToProps)(Description);

const impressionConfig = {
    DOMSelector: `.${CLASSNAME} .description-content`,
    eventKey: 'gig_description'
};

export { Description, ConnectedDescription };
export default SafePureComponent(WithImpressions(ConnectedDescription, impressionConfig));
